import { useEffect } from "react";
import styles from "../../css/toast.module.css";

export const TOAST_TTL = 5000;

// status: success/error/warning
function Toast({
    id,
    text,
    status,
    selfDestructible,
    executable,
    executableFunction,
    removeToast,
}) {
    // Izostavljeno `selfDestructible` znači „nestani sam" — takvih je 17 od 19
    // poziva. Lepljiva je samo ona koja to izričito traži.
    const sticky = selfDestructible === false;

    // Tajmer pripada SVOJOJ poruci, skida SEBE i čisti se pri odmontiranju.
    //
    // Zatečeni je stajao nad celom listom: uhvatio bi je kakva je bila u
    // trenutku zakazivanja i posle pet sekundi vratio umanjenu za prvu stavku.
    // Time je brisao i poruke nastale u međuvremenu — svaka koja bi stigla u
    // roku od pet sekundi posle neke druge nestajala je odmah. Lepljivost se
    // pri tom čitala sa POSLEDNJE stavke u nizu, pa je poruku o zastareloj
    // verziji, jedinu na koju se klikće, pomela bilo koja poruka posle nje.
    useEffect(() => {
        if (sticky) return;
        const timer = setTimeout(() => removeToast(id), TOAST_TTL);
        return () => clearTimeout(timer);
    }, [sticky, id, removeToast]);

    const executeOnClick = () => {
        if (executable) executableFunction();
        removeToast(id);
    };

    return (
        <div
            role="status"
            onClick={executeOnClick}
            className={` ${styles.toast} ${styles[status]} `}
        >
            <p> {text} </p>
        </div>
    );
}

export default Toast;
